import React from 'react';
import { Hero } from '../components/Hero';
import { Gallery } from '../components/Gallery';
import { Reviews } from '../components/Reviews';
import { TargetAudience } from '../components/TargetAudience';
import { Problem } from '../components/Problem';
import { Tomes } from '../components/Tomes';
import { Bonuses } from '../components/Bonuses';
import { Comparison } from '../components/Comparison';
import { Pricing } from '../components/Pricing';
import { ProTools } from '../components/ProTools';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-navy w-full overflow-x-hidden font-sans" data-id="element-331">
      <Hero data-id="element-332" />
      <Gallery data-id="element-333" />
      <Reviews data-id="element-334" />
      <TargetAudience data-id="element-335" />
      <Problem data-id="element-336" />
      <Tomes data-id="element-337" />
      <Bonuses data-id="element-338" />
      <Comparison data-id="element-339" />
      <Pricing data-id="element-340" />
      <ProTools data-id="element-341" />
      <Guarantee data-id="element-342" />
      <FAQ data-id="element-343" />
      <FinalCTA data-id="element-344" />
      <Footer data-id="element-345" />
    </main>;
}